import React, { useState, useEffect, useMemo } from "react";
import { Helmet } from "react-helmet";
import PerfectScrollbar from "react-perfect-scrollbar";
import { withStyles } from "@mui/styles";
import {
  Box,
  Button,
  Card,
  Container,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  TableContainer,
  Typography,
  Chip,
  Paper,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import LabelTwoToneIcon from "@mui/icons-material/LabelTwoTone";
import SearchField from "react-search-field";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#b5b6b7",
    color: "black",
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const options = [
  { id: 1, name: "Lab Name", value: "Lab_name" },
];

function a21yProps(value) {
  if (value === "SUNDAY") {
    return {
      style: { color: "rgb(228 3 3 / 94%)" },
      label: value,
      size: "small",
    };
  } else if (value === "MONDAY") {
    return {
      style: { color: "#007eec" },
      label: value,
      size: "small",
    };
  } else if (value === "TUESDAY") {
    return {
      style: { color: "#00a200" },
      label: value,
      size: "small",
    };
  } else if (value === "WEDNESDAY") {
    return {
      style: { color: "rgb(228 193 3 / 94%)" },
      label: value,
      size: "small",
    };
  } else if (value === "THURSDAY") {
    return {
      style: { color: "rgb(0 146 141 / 94%)" },
      label: value,
      size: "small",
    };
  } else if (value === "FRIDAY") {
    return {
      style: { color: "rgb(146 0 139 / 94%)" },
      label: value,
      size: "small",
    };
  } else {
    return {
      style: { color: "rgb(255 126 9 / 94%)" },
      label: value,
      size: "small",
    };
  }
}

function getTimeZoneAbbreviation(timeZone) {
  try {
    const date = new Date();
    const options = {
      timeZone,
      timeZoneName: 'short',
    };

    const formatter = new Intl.DateTimeFormat('en-US', options);
    const parts = formatter.formatToParts(date);
    const tzName = parts.find(part => part.type === 'timeZoneName')?.value;

    // A more comprehensive mapping for common abbreviations and offsets
    const fallbackMap = {
      // Common abbreviations
      "America/New_York": "EST",
      "America/Los_Angeles": "PST",
      "America/Denver": "MST",
      "America/Chicago": "CST",
      "Europe/London": "GMT",
      "Europe/Berlin": "CET",
      "Asia/Kolkata": "IST",
      "Asia/Tokyo": "JST",
      "Australia/Sydney": "AEST",
      
      // GMT offsets that might be returned
      "GMT+5:30": "IST",
      "GMT+1:00": "CET",
      "GMT+2:00": "EET",
      "GMT-4:00": "AST",
      "GMT-5:00": "EST",
      "GMT-6:00": "CST",
      "GMT-7:00": "MST",
      "GMT-8:00": "PST",
    };
    
    // Check if the timezone name or its offset equivalent exists in our map
    const mappedTz = fallbackMap[timeZone] || fallbackMap[tzName];

    return mappedTz || tzName || timeZone;
  } catch (e) {
    // Return a default or the original timezone name on error
    console.error("Error getting timezone abbreviation:", e);
    return timeZone;
  }
}


const UpcomingDialog = React.memo(({ lab_id }) => {
  const [open, setOpen] = useState(false);
  const [instancemoreinfoschlist, setInstanceMoreInfoSchlist] = useState([]);

  useEffect(() => {
    if (open) {
      fetch(`${process.env.REACT_APP_API_URL}/api/preconfiguredupcomingmoreinfolabs/${lab_id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((resp) => resp.json())
        .then((data) => {
          setInstanceMoreInfoSchlist(data || []);
        })
        .catch(console.error);
    }
  }, [open, lab_id]);

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const formatDate = (date) => new Date(date).toLocaleDateString("en-GB");
  const formatTime = (date, time) => new Date(`${date}T${time}:00.000Z`).toLocaleTimeString("en-GB", { hour: '2-digit', minute: '2-digit' });
  
  
  return (
    <>
      <TableCell>
        <Button onClick={handleClickOpen}><InfoIcon /></Button>
      </TableCell>
      <Dialog fullWidth maxWidth="md" open={open} onClose={handleClose}>
        <DialogTitle>
          <Chip icon={<LabelTwoToneIcon />} label="UPCOMING DAYS" />
          <span style={{ color: "red" }}>
            Start Date: {formatDate(instancemoreinfoschlist[0]?.Start_date)} - End Date: {formatDate(instancemoreinfoschlist[0]?.Stop_date)}
          </span>
        </DialogTitle>
        <DialogContent>
          <TableContainer component={Paper}>
            {instancemoreinfoschlist[0]?.Schedule_type === "always" ? (
              <Table>
              <TableHead>
                <TableRow>
                  <StyledTableCell>START DATE</StyledTableCell>
                  <StyledTableCell>END DATE</StyledTableCell>
                  <StyledTableCell>ON TIME</StyledTableCell>
                  <StyledTableCell>OFF TIME</StyledTableCell>
                  <StyledTableCell>TIME ZONE</StyledTableCell>
                </TableRow>
              </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>{formatDate(instancemoreinfoschlist[0]?.Start_date)}</TableCell>
                    <TableCell>{formatDate(instancemoreinfoschlist[0]?.Stop_date)}</TableCell>
                    <TableCell>{formatTime(instancemoreinfoschlist[0]?.Start_date, instancemoreinfoschlist[0]?.On_time) || "NA"}</TableCell>
                    <TableCell>{formatTime(instancemoreinfoschlist[0]?.Stop_date, instancemoreinfoschlist[0]?.Off_time) || "NA"}</TableCell>
                    <TableCell>{getTimeZoneAbbreviation(instancemoreinfoschlist[0]?.time_zone)}</TableCell>
                  </TableRow>
              </TableBody>
            </Table>
            ) : (
            <Table>
              <TableHead>
                <TableRow>
                  <StyledTableCell>DATE</StyledTableCell>
                  <StyledTableCell>DAY</StyledTableCell>
                  <StyledTableCell>ON TIME</StyledTableCell>
                  <StyledTableCell>OFF TIME</StyledTableCell>
                  <StyledTableCell>TIME ZONEeee</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {instancemoreinfoschlist.length > 0 ? instancemoreinfoschlist.map((lab) =>
                  lab.result.map((data) => (
                    <TableRow hover key={data.id}>
                      <TableCell>{formatDate(data.date)}</TableCell>
                      <TableCell><Chip {...a21yProps(new Date(data.date).toLocaleDateString('en-US', { weekday: 'long' }).toUpperCase())} /></TableCell>
                      <TableCell>{formatTime(lab.Start_date, lab.On_time) || "NA"}</TableCell>
                      <TableCell>{formatTime(lab.Start_date, lab.Off_time) || "NA"}</TableCell>
                      <TableCell>{getTimeZoneAbbreviation(lab.time_zone)}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={5} align="center">Currently no events are scheduled</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>)}
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
});

const CurrentSchedule = () => {
  const [instanceschlist, setInstanceSchlist] = useState([]);
  const [searchitems, setSearchItems] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/preconfiguredupcominglabs/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail) setInstanceSchlist(data);
      })
      .catch(console.error);
  }, []);

  const filteredData = useMemo(() => instanceschlist.filter(val =>
    val[options[0].value].toLowerCase().includes(searchitems.toLowerCase())
  ), [instanceschlist, searchitems]);

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      <Helmet><title>LabAsService</title></Helmet>
      <Box sx={{ backgroundColor: "background.default", minHeight: "100%", py: 3 }}>
        <Container maxWidth={false}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: "-50px" }}>
            <Typography sx={{ flex: "1 1 100%" }} style={{ fontSize: "x-large", lineHeight: "2.5" }} color="textPrimary" variant="body1">
              Preconfigured
            </Typography>
            <SearchField placeholder="Search by Lab Name" onChange={setSearchItems} classNames="test-class" />
          </Box>
          <Box sx={{ pt: 3 }}>
            <Card>
              <PerfectScrollbar>
                <Box sx={{ minWidth: 1000 }}>
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Date</TableCell>
                          <TableCell>Lab Name</TableCell>
                          <TableCell>No.of Trainee</TableCell>
                          <TableCell>On Time</TableCell>
                          <TableCell>Off Time</TableCell>
                          <TableCell>Scheduling Type</TableCell>
                          {/* <TableCell>Time Zone</TableCell> */}
                          <TableCell>more Info</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((instance) => (
                          <TableRow hover key={instance.Id}>
                            <TableCell>{new Date(instance.result[0].date).toLocaleDateString("en-GB")}</TableCell>
                            <TableCell>{instance.Lab_name}</TableCell>
                            <TableCell>{instance.Trainees}</TableCell>
                            <TableCell>{instance.On_time ? new Date(`${instance.Start_date}T${instance.On_time}:00.000Z`).toLocaleTimeString("en-GB", { hour: '2-digit', minute: '2-digit' }) : "NA"}</TableCell>
                            <TableCell>{instance.Off_time ? new Date(`${instance.Stop_date}T${instance.Off_time}:00.000Z`).toLocaleTimeString("en-GB", { hour: '2-digit', minute: '2-digit' }) : "NA"}</TableCell>
                            <TableCell>{instance.Schedule_type}</TableCell>
                            <TableCell>{getTimeZoneAbbreviation(instance.time_zone)}</TableCell>
                            <TableCell>
                              <UpcomingDialog lab_id={instance.lab_id} />
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-start', paddingLeft: '20px' }}>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={filteredData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                  </Box>
                </Box>
              </PerfectScrollbar>
            </Card>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default CurrentSchedule;